import styled from 'styled-components';

import { above } from '../../../assets/css/media';
import LeagueStatusLabel from './LeagueStatusLabel';


const LeagueStatusLabelStyled = styled(LeagueStatusLabel)`
	margin-right: 10px;
`;

export const CountdownTimerWrapper = styled.div`
	display: none;
	align-items: center;
	margin-right: 15px;

	${above.tablet`
		display: flex;
	`}
`;

export const CountdownLabel = LeagueStatusLabelStyled;


// WEBPACK FOOTER //
// ./src/pages/leagues/myLeagues/countdownTimerStyles.js